import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DatePickerIcon extends BaseIcon {
    getChildren = () => [
        <path fill={this.getColor()} d="M2,14V5h12v9H2z M6,7H4v2h2V7z M6,10H4v2h2V10z M9,7H7v2h2V7z M9,10H7v2h2V10z M12,7h-2v2h2V7z M12,10h-2v2h2 V10z M2,2h3V1h1v1h4V1h1v1h3v2H2V2z"/>
    ];
    getViewBox = () => '0 0 16 16'
}
